import config from "@/config";
import http from "@/utils/request";

export default {
	/**
	 * 签到模块
	 * */
	sign: {
		/**
		 * 签到配置模块
		 * */
		config: {
			/**
			 * 获取签到配置
			 */
			show: {
				url: `${config.API_URL}/sign/getConfig`,
				name: "获取签到配置",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			/**
			 * 保存签到配置
			 */
			save: {
				url: `${config.API_URL}/sign/updateConfig`,
				name: "保存签到配置",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
		},
		/**
		 * 签到奖励模块
		 * */
		reward: {
			/**
			 * 获取签到奖励列表
			 */
			list: {
				url: `${config.API_URL}/sign/getRewardList`,
				name: "获取签到奖励列表",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			/**
			 * 添加签到奖励
			 */
			add: {
				url: `${config.API_URL}/sign/addReward`,
				name: "添加签到奖励",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			/**
			 * 修改签到奖励
			 */
			update: {
				url: `${config.API_URL}/sign/updateReward`,
				name: "修改签到奖励",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			/**
			 * 删除签到奖励
			 */
			delete: {
				url: `${config.API_URL}/sign/deleteReward`,
				name: "删除签到奖励",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
		},
	},
	/**
	 * 商城模块
	 */
	shop: {
		/**
		 * 积分商品模块
		 */
		goods: {
			/**
			 * 获取积分商品列表
			 */
			list: {
				url: `${config.API_URL}/points_exchange/getList`,
				name: "获取积分商品列表",
				get: async function (data = {}) {
					return await http.get(this.url, data);
				},
			},
			/**
			 * 添加积分商品
			 */
			add: {
				url: `${config.API_URL}/points_exchange/create`,
				name: "添加积分商品",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			/**
			 * 修改积分商品
			 */
			update: {
				url: `${config.API_URL}/points_exchange/update`,
				name: "修改积分商品",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
			/**
			 * 删除积分商品
			 */
			delete: {
				url: `${config.API_URL}/points_exchange/delete`,
				name: "删除积分商品",
				post: async function (data = {}) {
					return await http.post(this.url, data);
				},
			},
		},
	},
};
